export enum ActorMovementType {
  Instant = 0,
  Walk = 1,
}
